<template>
  <b-card
    class="mb-3 p-0 c-pointer"
    style="height: 100%"
    :class="selectedProducts[product.id] ? 'shadow' : ''"
    :border-variant="selectedProducts[product.id] ? 'primary' : ''"
    @click.stop="$emit('select')"
  >
    <b-card-text class="fs-14">
      <div>
        <b-checkbox
          v-model="selectedProducts[product.id]"
          @change="$emit('select')"
        ></b-checkbox>
      </div>
      <div class="text-center mb-2">
        <b-img
          fluid
          :src="getImageLinkByOrigin(product.origem) + product.photo"
          style="min-height: 50px; max-height: 50px"
        >
        </b-img>
      </div>
      <div class="mb-2" :title="product.product">
        <span
          style="
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            min-height: 40px;
            max-height: 40px;
          "
        >
          {{ product.product }}
        </span>
      </div>
      <div class="d-flex align-items-center" @click.stop>
        <i class="far fa-money-bill-alt mr-2"></i>
        <span v-if="!editingPrice">
          {{ formatNumber(product.priceSalesFormat1) }}
        </span>
        <InputMoney
          v-else
          v-model="fields.priceSalesFormat1"
          style="height: 25px; width: 55%; font-size: 14px"
        />
        <i
          v-if="!editingPrice"
          class="far fa-edit ml-2 text-primary"
          title="Editar preço"
          @click.stop="startEditing"
        ></i>
        <div v-else>
          <i
            id="save-icon"
            class="far fa-check-circle ml-1 text-success"
            title="Salvar valor"
            v-if="!loading"
          ></i>
          <i
            class="far fa-trash-alt ml-2 text-danger"
            title="Cancelar edição"
            v-if="!loading"
            @click.stop="cancelEdit"
          ></i>
          <b-spinner v-if="loading" small class="ml-2"></b-spinner>

          <b-popover target="save-icon" placement="bottom">
            <template #title>Atualizar preço</template>
            Deseja atualizar o preço geral do produto somente para esta promoção
            ou para o sistema todo?
            <div
              class="d-flex flex-column justify-content-center mt-2"
              style="gap: 10px"
            >
              <b-button
                size="sm"
                variant="success"
                @click.stop="updateLocalPrice"
              >
                <i class="fas fa-check-circle mr-2"></i>
                Somente para esta promoção
              </b-button>
              <b-button
                size="sm"
                variant="warning"
                @click.stop="updateGeneralPrice"
              >
                <i class="fas fa-check-double mr-2"></i>
                Para o sistema todo
              </b-button>
            </div>
          </b-popover>
        </div>
      </div>
      <div :class="product.quantityStock <= 0 ? 'text-danger' : ''">
        <i class="fas fa-box mr-2"></i>
        Em estoque: {{ product.quantityStock }}
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { convertBrlToDecimal, formatNumber } from '@/utils';
import { getImageLinkByOrigin } from '@/utils/photos';
import InputMoney from '@/components/Inputs/InputMoney.vue';

export default {
  emits: ['updatePrice'],
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    selectedProducts: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  data() {
    return {
      loading: false,
      editingPrice: false,
      fields: {
        priceSalesFormat1: '',
      },
    };
  },
  methods: {
    ...mapActions('shopkeeper', ['updateSelectedProduct']),
    formatNumber,
    getImageLinkByOrigin,
    startEditing() {
      this.editingPrice = true;
      this.fields.priceSalesFormat1 = this.product.priceSalesFormat1;
    },
    cancelEdit() {
      this.editingPrice = false;
      this.fields.priceSalesFormat1 = '';
    },
    updateLocalPrice() {
      this.emitUpdatePrice(this.fields.priceSalesFormat1);

      this.editingPrice = false;
      this.fields.priceSalesFormat1 = '';
    },
    updateGeneralPrice() {
      this.loading = true;

      this.updateSelectedProduct({
        userId: this.dadosUsuario.id,
        product: {
          ...this.product,
          productId: this.product.id,
          priceSalesFormat1: this.fields.priceSalesFormat1,
        },
      })
        .then(() => {
          this.emitUpdatePrice(this.fields.priceSalesFormat1);
          this.cancelEdit();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    emitUpdatePrice(price) {
      this.$emit('updatePrice', convertBrlToDecimal(price).toFixed(2));
    },
  },
  components: {
    InputMoney,
  },
};
</script>
